// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/spin-recovery.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/spin-recovery/spin-recovery.js';

mount([g0]);
